/** See `src/i18n/locales/en/reports.ts`. */
export const reports = {
  page: {
    title: 'Relatórios',
    lead: 'Relatórios de {{company}}, construídos a partir de dados existentes — nenhum dado de relatório separado é armazenado.',
    noScope: 'Selecione uma empresa para ver os seus relatórios.',
    forbidden: 'Não tem permissão para ver os relatórios desta empresa.',
  },
  library: {
    title: 'Biblioteca de relatórios',
  },
  cards: {
    vitaliteitstrends: {
      title: 'Tendências mensais de vitalidade',
      description: 'Total de passos por mês em toda a empresa.',
    },
    deelnamerapport: {
      title: 'Relatório de participação',
      description: 'Quantos membros estão ativos, e há quanto tempo.',
    },
    'challenge-resultaten': {
      title: 'Resultados dos desafios',
      description: 'Desafios por estado e progresso médio dos participantes.',
    },
    communicatiebereik: {
      title: 'Alcance da comunicação',
      description: 'Notificações enviadas, entregues e abertas.',
    },
    documentgebruik: {
      title: 'Utilização de documentos',
      description: 'Documentos publicados/arquivados e o seu número total de visualizações.',
    },
  },
  actions: {
    exportCsv: 'Exportar CSV',
    exportPdf: 'Exportar PDF',
  },
  export: {
    pdfFallbackNote:
      'A exportação para PDF ainda não está disponível — foi descarregado um ficheiro CSV em vez disso.',
    error: 'Não foi possível exportar este relatório.',
  },
} as const;
